import { useState } from 'react';
import useUserProfile from '~/apis/useUserProfile';
import { useAuth } from '~/auth';
import { OnBoardAccountType } from './_partials/onboard-account-type';
import { OnBoardPackageType } from './_partials/onboard-package-type';
import { OnboardLegalDocs } from './_partials/onboard-legal-docs';

export const OnBoarding = () => {
   const { user, updateUser } = useAuth();
   const { refetch: refetchUser } = useUserProfile({
      onSuccess: data => {
         if (data && data.status) {
            updateUser({ ...user, ...data });
         }
      },
   });
   const [onboardingStep, setOnboardingStep] = useState<
      'user_type' | 'package_type' | 'upload_files' | 'in_review' | undefined
   >(user?.status === 'Under Review' ? 'in_review' : 'user_type');
   const [isDomesticUser, setIsDomesticUser] = useState<boolean>(false);
   const [isNusukUser, setIsNusukUser] = useState<boolean>(false);

   const resetAccountType = () => {
      setOnboardingStep('user_type');
      setIsDomesticUser(false);
      setIsNusukUser(false);
      updateUser({
         ...user,
         international: false,
         is_umrah: false,
         umrah_license_file: '',
      });
   };

   return (
      <div className="p-5">
         <div className="h-full">
            {onboardingStep === 'user_type' ? (
               <OnBoardAccountType
                  accountTypeSelection={(type: 'international' | 'domestic') => {
                     setIsDomesticUser(type === 'domestic');
                     setIsNusukUser(false);
                     updateUser({
                        ...user,
                        international: type === 'international',
                        is_umrah: false,
                     });
                     setOnboardingStep(type === 'international' ? 'upload_files' : 'package_type');
                  }}
               />
            ) : onboardingStep === 'package_type' ? (
               <OnBoardPackageType
                  packageTypeSelection={(type: 'domestic' | 'is_umrah') => {
                     setIsDomesticUser(type === 'domestic');
                     setIsNusukUser(type === 'is_umrah');
                     updateUser({
                        ...user,
                        international: false,
                        is_umrah: type === 'is_umrah',
                     });
                     setOnboardingStep('upload_files');
                  }}
                  resetAccountType={() => resetAccountType()}
               />
            ) : (
               <OnboardLegalDocs
                  showPackageSelection={() => {
                     setOnboardingStep('package_type');
                  }}
                  docsUploaded={() => {
                     refetchUser();
                  }}
                  isDomesticUser={isDomesticUser}
                  isNusukUser={isNusukUser}
                  resetAccountType={() => resetAccountType()}
                  showInReview={onboardingStep === 'in_review'}
               />
            )}
         </div>
      </div>
   );
};
